import React, { Component } from 'react';
import { getFileName } from 'helpers/FileCaching';
import classes from './Author.module.scss';
import articlesJSON from 'data/articles.json'
import authorsJSON from 'data/authors.json'

const authorImages = require.context('images/components/Articles/Article/Author/', true, /.*\.(gif|png|jpe?g|svg)$/i);

class Author extends Component {

    constructor(props){

        super();
        let authorID = props.content
       
        this.state = {
            content:authorsJSON.authors.find( author => author.id == authorID ),
        }

    }

    componentWillReceiveProps(nextProps){

        let authorID = nextProps.content

        this.setState({
            content:authorsJSON.authors.find( author => author.id == authorID )
        })

    }

    render(){
        let authorAvatar =  this.state.content.avatar;
   
        if(authorAvatar){
            authorAvatar = 
                <span

                    className={classes.author__avatar}
                    style={ 
                        {
                            background: 'url(' + getFileName(authorImages, this.state.content.avatar) + ') no-repeat center center'
                        }
                    }

                />
     
        }
        return (
            <div className={classes.author}>
                <div className={classes.author__Container}>
           
                    <div className={classes['author__avatar-wrapper']}>
                        {authorAvatar}
                    </div> 
                    <p className={classes['author__name']}>{articlesJSON.text.authorBy} {this.state.content.name}</p>
                    
            </div>
            <div className={classes['author__bottom-line']}></div>
            </div>
        );
    }
}

export default Author;